import { gql } from '__generated__'

export const TrackRecruiterRosterView = gql(/* GraphQL */ `
    mutation TrackRecruiterRosterView($rosterId: String!) {
        trackRecruiterRosterView(rosterId: $rosterId) {
            success
        }
    }
`)
